import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { doSupabaseCall } from '../../shared/helpers/supabase.helper';
import type { IFaseZeroEsiti } from '../../shared/models';
import { AuthService } from '../auth/auth.service';
import { SupabaseService } from '../supabase/supabase';

// Esiti della Fase Zero (Specifica_Sviluppatori_FaseZero §4): una riga per intervista, upsert su
// fk_interview_app_id come interview_ponderazione_app — una rigenerazione aggiorna, mai uno storico.
@Injectable({ providedIn: 'root' })
export class FaseZeroService {
  private readonly _supabase: SupabaseService = inject(SupabaseService);
  private readonly _auth: AuthService = inject(AuthService);

  public save(interviewId: string, esiti: IFaseZeroEsiti, promptVersionId: string | null): Observable<void> {
    const client = this._supabase.client;
    const session = this._auth.sessionSignal();
    if (null === client || null === session) {
      return of(undefined);
    }
    return doSupabaseCall(
      client.from('interview_fase_zero_app').upsert(
        {
          fk_interview_app_id: interviewId,
          temi: esiti.temi.map((t) => ({
            tema_id: t.temaId,
            titolo: t.titolo,
            stato_finale: t.stato,
            timestamp_registrazione: t.timestampRegistrazione,
            testo_domanda: t.domanda,
            testo_risposta: t.risposta.trim() || null,
            origine_non_chiarito: t.origineNonChiarito,
          })),
          n_congruenti: esiti.nCongruenti,
          n_chiariti: esiti.nChiariti,
          n_non_chiariti: esiti.nNonChiariti,
          conteggio_divergente: esiti.conteggioDivergente,
          fk_app_prompt_id: promptVersionId,
          fk_auth_users_id: session.user.id,
        },
        { onConflict: 'fk_interview_app_id' },
      ),
    ).pipe(map(() => undefined));
  }
}
